// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"923":"b2cdcbb3","931":"c792e5b8"}[chunkId] + ".css";
};